module.exports = __webpack_public_path__ + "static/media/plus-blue.43d2a988.svg";